import {DefinitionBase, ListItemContainerProps} from './managerTypes.ts';
import {Checkbox, ListItem, ListItemButton} from '@mui/material';
import React from 'react';
import {stopPropagation} from '../../../../lib/stdFuncs.ts';

export default function ListItemContainer<D extends DefinitionBase>({
    item,
    selectedItem,
    handleItemClick,
    setSelection,
    selection,
    listComponent,
    onDelete,
    onUpdate,
}: ListItemContainerProps<D>) {
    return (
        <>
            <ListItem disablePadding>
                <ListItemButton
                    onClick={handleItemClick(item)}
                    selected={selectedItem?.id === item.id}
                >
                    {selection ? (
                        <div
                            onMouseDown={stopPropagation}
                            onClick={stopPropagation}
                        >
                            <Checkbox
                                sx={{ml: -2}}
                                checked={selection.includes(item.id)}
                                onChange={e => {
                                    if (e.target.checked) {
                                        setSelection(s => [...s, item.id]);
                                    } else {
                                        setSelection(s =>
                                            s.filter(id => id !== item.id)
                                        );
                                    }
                                }}
                            />
                        </div>
                    ) : null}
                    {React.createElement(listComponent, {
                        key: item.id,
                        data: item,
                        onEdit: handleItemClick(item, true),
                        onDelete: onDelete ? () => onDelete(item) : undefined,
                        onUpdate,
                    })}
                </ListItemButton>
            </ListItem>
        </>
    );
}
